<template>
  <div class="stats-widget hidden-print-only">
    <template v-if="dataCollection">
      <line-chart
        v-if="type === 'line'"
        class="graph pb-2"
        :chart-data="dataCollection"
      />
      <stacked-bar-chart
        v-else-if="type === 'stackedBar'"
        class="graph pb-2"
        :chart-data="dataCollection"
      />
      <bar-chart
        v-else-if="type === 'bar'"
        class="graph pb-2"
        :chart-data="dataCollection"
      />
    </template>
    <!--<div class="separator"></div>
    <div class="actions pt-4">
      <span class="period">Últimas 24 horas</span>
    </div>-->
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import LineChart from './LineChart';
  import { IStatItem } from '../../interfaces/IStatItem';
  import { IStatGroup } from '../../interfaces/IStatGroup';
  import { IStats } from '../../interfaces/IStats';
  import StackedBarChart from './StackedBarChart';
  import BarChart from './BarChart';

  @Component({
    components: { BarChart, StackedBarChart, LineChart },
  })
  export default class StatsWidget extends Vue {
    @Prop() label: string;
    @Prop() stats: IStats;
    @Prop({ default: 'line' }) type: string;
    @Prop({ default: '' }) valuePrefix: string;
    colors: string[] = [
      '#45a5f5',
      '#53f588',
      '#f5e938',
      '#f56041',
      '#f5418a',
      '#c44ff5',
      '#6451f5',
    ];
    dataCollection = null;

    async created() {
      this.update();
    }

    @Watch('stats')
    onStatsChanged() {
      this.update();
    }

    /*@Watch('options', { deep: true })
    onOptionsChanged() {
      this.update();
    }*/

    update() {
      if (!this.stats) return;
      const datasets = [];

      let index = 0;
      for (const group of this.stats.groups) {
        const data = [];
        const color = group.color || this.colors[index++];

        for (const stat of group.stats) {
          data.push(stat.value);
        }

        datasets.push({
          label: group.title,
          borderColor: color,
          backgroundColor: color + (this.type === 'line' ? '11' : 'ff'),
          //backgroundColor: 'transparent',
          data: data,
          fill: true,
          cubicInterpolationMode: 'monotone',
          lineTension: 0, // Linear
        });
      }

      this.dataCollection = {
        labels: this.stats.labels,
        datasets,
      };
    }

    requestUpdate() {
      this.$emit('refresh');
    }
  }
</script>
